import initialState from '../app.state.jsx';
import autocompleteReducer from './autocomplete/reducer.jsx';
import { twinControlReducer } from './multibirth/reducer.jsx';
import ld from 'lodash';
import { AnalyticsService } from '../../fht/analytics';

function _evalRoot(root, name) {
    const SINGLE_SPACE = ' ';
    if (root) { return `${root} ${name}`.trim().split(SINGLE_SPACE); }
    return [name];
}

export function timeReducer(state) {
    let totalTimeSpent = state.get('timeSpent') || 0;
    const finished = state.get('finished');
    const timeModified = state.get('timeModified');
    const currentTime = new Date();
    const timeSpent = Math.round((currentTime - new Date(timeModified)) / 1000);
    if (!finished) { totalTimeSpent = 0 < totalTimeSpent ? totalTimeSpent + timeSpent : timeSpent; }
    return state.set('timeModified', new Date()).set('timeSpent', totalTimeSpent);
}

export function setFieldValueReducer(state, action) {
    const twinReducerProcessedState = twinControlReducer(state, action);
    if (ld.startsWith(action.name, '__')) { return twinReducerProcessedState; }
    const timeMarkedState = timeReducer(twinReducerProcessedState);
    return timeMarkedState.setIn(_evalRoot(action.root, action.name), action.value);
}

export function resetFieldValueReducer(state, action) {
    return twinControlReducer(state, action).deleteIn(_evalRoot(action.root, action.name));
}

export default function componentsReducer(state = initialState.get('components'), action = null) {
    return state.set('autocomplete', autocompleteReducer(state.get('autocomplete'), action));
}

export function completeQuestionnaireReducer(state, action) {
    AnalyticsService.logEvent({type: 'Questionnaire Completed'});
    return state.set('finished', true)
                .setIn([ 'pages', 'lastPageIndex' ], action.lastPageIndex)
                .setIn([ 'pages', 'currentPageIndex' ], action.lastPageIndex);
}
